import React, { memo, RefObject, forwardRef } from "react";
import { ScrollSyncPane } from "react-scroll-sync";
import {
	Row,
	UseRowStateInstanceProps,
	UseTableInstanceProps,
} from "react-table";

import { NoRecords } from "./noRecords";
import { TableRow } from "./row";

import styles from "./table.module.scss";

const defaultProps = {
	rows: [],
};

type TableBodyProps = {
	tableRowClassName?: string;
	minWidth?: string;
	isOddRowBackground?: boolean;
	isInfinityScrollEnabled?: boolean;

	rows: Array<Row>;
	onRowClick?: (row: { [key: string]: any }) => any;
	handleRowSubmit?: ({
		values,
		row,
		setRowState,
	}: {
		values: { [key: string]: any };
		row: { [key: string]: any };
		setRowState: any;
	}) => any;
	customRowClassName?: (row: any) => string | false;
	handleRowModified?: Function;
	scrollRef?: ((node?: Element | null) => void) | RefObject<HTMLDivElement>;
} & Pick<UseRowStateInstanceProps<any>, "setRowState"> &
	Pick<UseTableInstanceProps<any>, "getTableBodyProps" | "prepareRow">;

// Each row is rerendered on change
// because of 'row' being passed
// but 'row' is  currently kept to provide more extensibility
const TableBody = forwardRef<HTMLDivElement, TableBodyProps>(
	(
		{
			getTableBodyProps,
			prepareRow,
			rows = defaultProps.rows,
			setRowState,
			onRowClick,
			handleRowSubmit,
			minWidth,
			customRowClassName,
			tableRowClassName,
			isOddRowBackground,
			scrollRef,
			isInfinityScrollEnabled,
		},
		ref,
	) => (
		<ScrollSyncPane group={["horizontal", "vertical"]}>
			<div {...getTableBodyProps()} className={styles.body}>
				<div
					className={styles.bodyInner}
					style={{ minWidth }}
					ref={ref}
				>
					{rows.map((row, i) => {
						prepareRow(row);
						return (
							<TableRow
								onRowClick={onRowClick}
								row={row}
								key={row.id}
								setRowState={setRowState}
								handleRowSubmit={handleRowSubmit}
								customRowClassName={customRowClassName}
								tableRowClassName={tableRowClassName}
								isOddRowBackground={isOddRowBackground}
								scrollRef={scrollRef}
							/>
						);
					})}
					{!rows.length && <NoRecords />}
				</div>
			</div>
		</ScrollSyncPane>
	),
);

const Component = memo(TableBody); // This memo might cause issue with editable table.
export { Component as TableBody }; // TODO: Remove it\comment if works properly
